<template>
  <NuxtLayout :name="layoutName" :navbar-color="layoutNavbarColor" :footer-color="layoutFooterColor">
    <div class="partner-page">
      <div class="container container--section">
        <section>
          <nav>
            <BaseLink
              :address="{ cached_url: '/partners', anchor: 'filter-results' }"
              class="partner-page__nav-link"
            >
              ← Back
            </BaseLink>
          </nav>
          <div class="partner-page__logo">
            <BaseNuxtImage
              v-if="story.content.logo"
              width="300"
              height="auto"
              :src="story.content.logo.filename"
              :alt="story.content.logo.alt"
            />
          </div>
          <div class="partner-page__tags">
            <StoryblokComponent
              v-for="childBlok in story.content.tags"
              :key="childBlok._uid"
              :blok="childBlok"
            />
          </div>
        </section>
        <section>
          <StoryblokComponent
            v-for="childBlok in story.content.content"
            :key="childBlok._uid"
            :blok="childBlok"
          />
        </section>
      </div>
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
import type { PartnersStoryblok } from '@/types'

const { slug } = useRoute().params
const { story } = await useFetchStory<PartnersStoryblok>(`partners/${slug}`, {
  additionalValidation: (story) => {
    return !story.content.generate_partner_page
  },
}).catch((error) => {
  throw createError({
    message: error,
    statusCode: 404,
  })
})

definePageMeta({
  key: (route) => route.fullPath,
})
useCustomHead(story)
false && /*#__PURE__*/ defineI18nRoute({
  locales: ['en'],
})
const { layoutName, layoutNavbarColor, layoutFooterColor } = useLayout<any>(story)
</script>

<style lang="scss" scoped>
.partner-page {
  background-color: var(--gray-100);
  padding-top: 40px;

  @media (min-width: $breakpoint-lg) {
    padding-top: 56px;
  }

  &__nav-link {
    @include heading-subheading;

    color: var(--color-link);
  }

  &__logo {
    text-align: center;
    margin: 40px 0 48px;

    @media (min-width: $breakpoint-lg) {
      margin-top: 56px;
    }

    & img {
      width: 300px;
    }
  }
}

.container--section {
  @media (min-width: $breakpoint-lg) {
    max-width: 868px;
  }
}
</style>
